import ProgramDetail from "@/views/layanan/program/ProgramDetail.vue";
import ProgramForm from "@/views/layanan/program/ProgramForm.vue";
import ProgramIndex from "@/views/layanan/program/ProgramIndex.vue";

const program = [
    {
        path: '/programs',
        name: 'program',
        component: ProgramIndex,
        meta: {
            requiresAuth: true,
            roles: ['Super Admin', 'Admin Office'], 
        },
    },
    {
        path: '/programs/add',
        name: 'programAdd',
        component: ProgramForm,
        meta: {
            requiresAuth: true,
            roles: ['Super Admin', 'Admin Office'], 
        },
    },
    {
        path: '/programs/edit/:uuid',
        name: 'programEdit',
        component: ProgramForm,
        meta: {
            requiresAuth: true,
            roles: ['Super Admin', 'Admin Office'], 
        },
    },
    {
        path: '/programs/detail/:uuid',
        name: 'programDetail',
        component: ProgramDetail,
        meta: {
            requiresAuth: true,
            roles: ['Super Admin', 'Admin Office'], 
        },
    }
]

export default program